import {PermissionType} from '../../../common/types'
import {CreateSlice} from '../../../base/store'
import {Role, ProfileRole, User} from '../'

export interface UsersSlice {
  userInfo: User
  role: ProfileRole
  permissions: undefined | null | PermissionType[]
  setUserInfo: (userInfo: User) => void
  setRole: (role: Role) => void
  setPermissions: (permissions?: PermissionType[]) => void
}

const createUsersSlice: CreateSlice<UsersSlice> = (set) => ({
  userInfo: null,
  role: null,
  permissions: null,
  setUserInfo: (userInfo) => set(() => ({ userInfo })),
  setRole: (role) =>
    set(() => ({
      role: role
        ? {
            root: role === 'root',
            director: role === 'director',
            coordinator: role === 'coordinator',
            controller: role === 'controller',
            manager: role === 'manager' || role === 'associated-manager',
            'associated-manager': role === 'associated-manager',
            user: role === 'user',
            broker: role === 'broker',
          }
        : null,
    })),
    setPermissions: (permissions) => set(() => ({ permissions })),
})

export default createUsersSlice
